Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsAISummaryView extends Backbone.View
  className: 'ticket-details-ai-summary'
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_details_ai_summary"]

  events:
    'click .reload' : '_onClickReload'

  initialize: (@options = {}) ->
    @ticket = @options.ticket
    @listenTo(@ticket, 'ticket:newLoaded', @_showReloadButton)

  render: =>
    @$el.html(@template())
    @listenTo(@ticket, 'aisummary:loaded', @_renderAISummary)
    @ticket.loadAISummary()
    @

  _showReloadButton: (newInteractions) =>
    if newInteractions.length > 0
      @$el.find('.reload').css('display', 'inline')

  _renderAISummary: (aiSummary) ->
    @$el.find('.updated-at').html((new Date()).toLocaleString())
    @$el.find('.loading-spinner').css('display', 'none')
    @$el.find('.ai-summary-header').css('display', 'inline')
    @$el.find('.ai-summary-content').css('display', 'inline')
    @$el.find('.ai-summary-content').html(@_markdownToHtml(aiSummary))

  _onClickReload: () ->
    @$el.find('.loading-spinner').css('display', 'inline')
    @$el.find('.ai-summary-header').css('display', 'none')
    @$el.find('.reload').css('display', 'none')
    @$el.find('.ai-summary-content').css('display', 'none')
    @ticket.loadAISummary(true)

  _markdownToHtml: (markdown) ->
    converter = new showdown.Converter()
    converter.makeHtml(markdown)
